import {
  ADD_ASSESSMENT,
  ADD_OBJECTIVE,
  ADD_PLAN,
  ADD_SUBJECTIVE,
  GET_ASSESSMENTS,
  GET_OBJECTIVES,
  GET_PLANS,
  GET_SUBJECTIVES,
  UPDATE_ASSESSMENT,
  UPDATE_OBJECTIVE,
  UPDATE_PLAN,
  UPDATE_SUBJECTIVE,
} from "./soapNoteActions";

const initialState = {
  subjectives: [],
  subjective: null,
  objectives: [],
  objective: null,
  assessments: [],
  assessment: null,
  plans: [],
  plan: null,
};

const soapNoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBJECTIVES:
      return {...state, subjectives: action.subjectives};
    case ADD_SUBJECTIVE:
    case UPDATE_SUBJECTIVE:
      return {...state, subjective: action.subjective};

    case GET_OBJECTIVES:
      return {...state, objectives: action.objectives};
    case ADD_OBJECTIVE:
    case UPDATE_OBJECTIVE:
      return {...state, objective: action.objective};

    case GET_ASSESSMENTS:
      return {...state, assessments: action.assessments};
    case ADD_ASSESSMENT:
    case UPDATE_ASSESSMENT:
      return {...state, assessment: action.assessment};

    case GET_PLANS:
      return {...state, plans: action.plans};
    case ADD_PLAN:
    case UPDATE_PLAN:
      return {...state, plan: action.plan};

    default:
      return state;
  }
};

export default soapNoteReducer;
